'use client';
import React, { Component } from 'react';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Team from '../reusable-components/layouts-components__gapresource/team';
import Task from '../reusable-components/layouts-components__gapresource/task';
import History from '../reusable-components/layouts-components__gapresource/history';
import Process from '../reusable-components/layouts-components__gapresource/process';
import Results from '../reusable-components/layouts-components__gapresource/results';
import Integration from '../reusable-components/layouts-components__gapresource/integration';
import Development from '../reusable-components/layouts-components__gapresource/development';
import Design from '../reusable-components/layouts-components__gapresource/design';

import './style.sass';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import CommonNav from '../common-components/common-nav';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const gensMainTitle = {
    titleMainText: 'Мультиязычный сайт для агрохолдинга',
    titleAnimation: '/images/pic/gapresource/main.png',
    subText: {
        text: 'В этом кейсе покажем поэтапно, как команда агентства «Вебпрактик» проектировала и разработала новый сайт Группы агропредприятий «Ресурс».',
        color: '#65B227',
    },
    subtitleContainer: [
        {
            modeText: 'Клиент',
            colorMode: '#65B227',
            nameText:
                'Группа агропредприятий «Ресурс» работает на рынке с 2002 года, является одним из крупнейших российских производителей продовольственной продукции и занимает ведущие позиции среди отечественных экспортеров мяса птицы и подсолнечного масла. Продукция Компании под брендами «Благояр», «Наша Птичка», AN-NOOR, URUSSA, «Дым Дымыч», «Чистое золото» и другими представлена на рынках 60 государств мира.',
        },
    ],
};

const nextProjectGens = {
    marketing: true,
    nextProjectTitle: 'Кейс по разработке корпоративного портала для фармкомпании',
    nextProjectImg: '/images/pic/promomed/main.png',
    nextProjectLink: '/cases/development/promomed',
    nextProjectLinkTitle: 'Фармацевтика',
    nextProjectText:
        'Мы расскажем, как разрабатывали корпоративный портал для компании «Промомед», который помог автоматизировать бизнес-процессы, повысить лояльность сотрудников и стать единой точкой доступа к корпоративной информации и сервисам.',
};

class Gapresource extends Component {
    render() {
        return (
            <section>
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Разработка"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <MainTitle
                    MainTitle={gensMainTitle}
                    classNameTitle="gapresource__main-title"
                    className="gapresource-container"
                />
                <History />
                <Task />
                <Process />
                <Design />
                <Integration />
                <Development />
                <Results />
                <Team />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectGens} />
            </section>
        );
    }
}

export default Gapresource;
